export default function (app) {
	app.directive('warningMessage', function () {
		return {
			restrict: 'A',
			scope: {
				warningMessage: '<'
			},
			link: (scope, elm) => {
				scope.$watch('warningMessage', function (newVal) {
					if (!newVal) {
						elm.css('display', 'none');
					} else {
						elm.css('display', 'block');
					}
				});
			}
		};
	});
}
